var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v(" "+_vm._s(_vm.title)+" "),(_vm.tooltip)?_c('a-tooltip',{attrs:{"title":_vm.tooltip,"placement":_vm.tooltipPlacement}},[_c('a-icon',{staticClass:"tooltip-icon",attrs:{"type":"info-circle"}})],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }